export const hasReportValue = (value: unknown): boolean =>
  value !== null && value !== undefined && String(value).trim() !== '' && Number.isFinite(Number(value))

export const isZeroReportValue = (value: unknown): boolean => hasReportValue(value) && Number(value) === 0

export const hasMeaningfulComparison = (current: unknown, previous: unknown, diff: unknown): boolean =>
  hasReportValue(current) && hasReportValue(previous) && hasReportValue(diff) &&
  !(isZeroReportValue(current) && isZeroReportValue(previous))
